/* eslint-disable react/prop-types */
import { LoadingHandler } from '@greenville/framework';
import React, { useEffect } from 'react';
import { inject, observer } from 'mobx-react';
// import Asset from '../../models/Asset';
import TOCDisplay from '../TOCDisplay';
import Loader from '../../../../common/Loader';
import { RPLUS, AI_STUDY_TOOLS } from '../../../../common/constants';

const ChatDataToc = (props) => {
  const { assetTOC, assetTocStatus, match, viewType, tenantName } = props;
  const tocBookId = tenantName ? match.url.split('/')[5] : match.params.bookId;
  const tenantNameVal = tenantName || match.url.split('/')[2];
  useEffect(() => {
    if (tenantNameVal && tenantNameVal !== RPLUS && tenantNameVal !== AI_STUDY_TOOLS) {
      assetTOC.fetch({ bookId: tocBookId, tenantNameVal });
    } else {
      assetTOC.fetch({ bookId: tocBookId });
    }
  }, []);
  return (
    <>
      <LoadingHandler
        loading={assetTocStatus.isPending}
        loadingContent={<Loader />}
        content={
          <TOCDisplay assetTOC={assetTOC} tocBookId={tocBookId} viewType={viewType} tenantName={tenantNameVal} />
        }
      />
    </>
  );
};

export default inject('assetTOC', 'assetTocStatus')(observer(ChatDataToc));
